import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function getRooms() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/rooms/get-by-owner');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_STATISTIC_ROOMS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_STATISTIC_ROOMS', data: []})
      return Promise.reject({message: 'Bag request'})
    }
  }
}

export function getQuizs(room_id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_STATISTIC_ROOMS_LOADED_QUIZS', data: false})
      const {data} = await axios.get('/api/quizs/get-by-room?id='+room_id);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_STATISTIC_QUIZS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_STATISTIC_QUIZS', data: []})
      return Promise.reject({message: 'Bag request'})
    }
  }
}

export function setRoomItem(data) {
  return async (dispatch) => {
    dispatch({type: 'SET_STATISTIC_ROOM', data: data})
  }
}

export function setQuizItem(data) {
  return async (dispatch) => {
    dispatch({type: 'SET_STATISTIC_QUIZ', data: data})
  }
}

export function getQuizStatistic(quiz_id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/quizs/statistic?quiz_id='+quiz_id);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_STATISTIC_QUIZ_REPORT', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_STATISTIC_QUIZ_REPORT', data: []})
      return Promise.reject({message: 'Bag request'})
    }
  }
}

export function getQuizStudentAnswers(quiz_id, student_id, formatMessage) {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/quizs/student-answers?quiz_id='+quiz_id + '&student_id=' + student_id);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_STATISTIC_QUIZ_STUDENT_ANSWERS', data: payload});
        if(payload.length == 0){
          toastr.error(formatMessage('stNotEndQuiezTitle'), formatMessage('stNotEndQuiezMessage'))
        }
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_STATISTIC_QUIZ_STUDENT_ANSWERS', data: []})
      return Promise.reject({message: 'Bag request'})
    }
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StatisticReports/actions.js